import { render } from "./TabAddress.vue?vue&type=template&id=8714f738"
import script from "./TabAddress.vue?vue&type=script&lang=js"
export * from "./TabAddress.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__